import { useContext, useState } from "react";
import { NumberFormatContext } from "@/shared/lib/number-format";
import type { NumberFormat } from "@/shared/lib/user-setting";

export const useNumberFormat = () => {
  const context = useContext(NumberFormatContext);
  if (!context) {
    throw new Error("useNumberFormat must be used within a NumberFormatProvider");
  }
  return context;
};

export const usePinnedNumberFormat = (open: boolean): NumberFormat => {
  const { numberFormat } = useNumberFormat();
  const [pin, setPin] = useState({ open, numberFormat });
  if (pin.open !== open) {
    setPin({ open, numberFormat });
    return numberFormat;
  }
  return open ? pin.numberFormat : numberFormat;
};
